/*
 * @Description: 实时定位驾驶舱 — A2「成员列表」本地 mock
 *   userId/name 与 locations.mock 一一对应，保证地图气泡 ↔ 列表项的双向联动。
 */
import { RealtimeMembersData } from '../types/cockpit.types'

export const MOCK_REALTIME_MEMBERS: RealtimeMembersData = {
  total: 12,
  stateStats: { online: 7, offline: 3, lowBattery: 3 },
  items: [
    {
      userId: 'mock-u1',
      name: '徐兴泽',
      avatar: '',
      department: '物业部 · 巡检一组',
      imei: '862000000000001',
      deviceNo: 'TM-1001',
      online: true,
      battery: 80,
      signal: 4,
      gpsStatus: 1,
      lastOnlineAt: 1780907268090,
      location: '113.9412,22.5470',
      locateTime: 1780907268090,
      address: '深圳市南山区科技园南区'
    },
    {
      userId: 'mock-u2',
      name: '张三',
      avatar: '',
      department: '物业部 · 巡检一组',
      imei: '862000000000002',
      deviceNo: 'TM-1002',
      online: true,
      battery: 65,
      signal: 3,
      gpsStatus: 1,
      lastOnlineAt: 1780907190000,
      location: '113.9430,22.5482',
      locateTime: 1780907190000,
      address: '深圳市南山区高新南一道'
    },
    {
      userId: 'mock-u3',
      name: '李四',
      avatar: '',
      department: '物业部 · 巡检二组',
      imei: '862000000000003',
      deviceNo: 'TM-1003',
      online: true,
      battery: 42,
      signal: 4,
      gpsStatus: 1,
      lastOnlineAt: 1780907100000,
      location: '113.9435,22.5485',
      locateTime: 1780907100000,
      address: '深圳市南山区高新南一道'
    },
    {
      userId: 'mock-u4',
      name: '王五',
      avatar: '',
      department: '安保部 · 一组',
      imei: '862000000000004',
      deviceNo: 'TM-1004',
      online: true,
      battery: 90,
      signal: 5,
      gpsStatus: 1,
      lastOnlineAt: 1780906900000,
      location: '113.9521,22.5391',
      locateTime: 1780906900000,
      address: '深圳市南山区深南大道'
    },
    {
      userId: 'mock-u5',
      name: '赵六',
      avatar: '',
      department: '安保部 · 一组',
      imei: '862000000000005',
      deviceNo: 'TM-1005',
      online: true,
      battery: 55,
      signal: 3,
      gpsStatus: 1,
      lastOnlineAt: 1780906800000,
      location: '113.9602,22.5333',
      locateTime: 1780906800000,
      address: '深圳市南山区滨海大道'
    },
    {
      userId: 'mock-u6',
      name: '孙七',
      avatar: '',
      department: '安保部 · 二组',
      imei: '862000000000006',
      deviceNo: 'TM-1006',
      online: true,
      battery: 30,
      signal: 2,
      gpsStatus: 1,
      lastOnlineAt: 1780906700000,
      location: '113.9288,22.5510',
      locateTime: 1780906700000,
      address: '深圳市南山区沙河西路'
    },
    {
      userId: 'mock-u7',
      name: '周八',
      avatar: '',
      department: '保洁部 · 一组',
      imei: '862000000000007',
      deviceNo: 'TM-1007',
      online: true,
      battery: 73,
      signal: 4,
      gpsStatus: 1,
      lastOnlineAt: 1780906600000,
      location: '113.9295,22.5515',
      locateTime: 1780906600000,
      address: '深圳市南山区沙河西路'
    },
    {
      userId: 'mock-u8',
      name: '吴九',
      avatar: '',
      department: '保洁部 · 一组',
      imei: '862000000000008',
      deviceNo: 'TM-1008',
      online: false,
      battery: 18,
      signal: 1,
      gpsStatus: 0,
      lastOnlineAt: 1780880000000,
      location: '113.9710,22.5280',
      locateTime: 1780880000000,
      address: '深圳市福田区车公庙'
    },
    {
      userId: 'mock-u9',
      name: '郑十',
      avatar: '',
      department: '保洁部 · 二组',
      imei: '862000000000009',
      deviceNo: 'TM-1009',
      online: false,
      battery: 12,
      signal: 0,
      gpsStatus: 0,
      lastOnlineAt: 1780875000000,
      location: '113.9180,22.5600',
      locateTime: 1780875000000,
      address: '深圳市南山区西丽'
    },
    {
      userId: 'mock-u10',
      name: '钱十一',
      avatar: '',
      department: '安保部 · 二组',
      imei: '862000000000010',
      deviceNo: 'TM-1010',
      online: false,
      battery: 5,
      signal: 0,
      gpsStatus: 0,
      lastOnlineAt: 1780870000000,
      location: '113.9805,22.5210',
      locateTime: 1780870000000,
      address: '深圳市福田区香蜜湖'
    }
  ]
}
